<template>
  <div class="container">
    <Layout/>
  </div>
</template>
<script>
  import Layout from '@/components/Layout'
  import BInput from "buefy/src/components/input/Input";
  export default {
    components: {BInput, Layout},
  }
</script>